import { createSlice } from "@reduxjs/toolkit";
import { addCouponsAPI } from "../../api/coupons";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const addCouponsSlice = createSlice({
  name: "addCoupons",
  initialState: data,
  reducers: {
   addCouponsSlice(state) {
      state.isLoading = true;
    },
   addCouponsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    addCouponsSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   addCouponsSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const addCouponsHandler: any = (data:any) => async (dispatch: any) => {
  try {
    dispatch(addCouponsAction.addCouponsSlice());
    const response: any = await addCouponsAPI(data);
    
    dispatch(addCouponsAction.addCouponsSliceSuccess(response));
  } catch (e: any) {
    dispatch(addCouponsAction.addCouponsSliceFailure(e?.response?.data));
  }
};
export default addCouponsSlice.reducer;
export const addCouponsAction = addCouponsSlice.actions;
